import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import {ApiService} from '../api/api.service';
import { ConstantsService } from '../constants/constants.service';

@Injectable({
  providedIn: 'root'
})
export class MetricIconService {
    data: any = {};
    metrics:any = {};
    metrics_parent_map = new Map();
    METRICS_ICON_MAP = ConstantsService.METRICS_ICON_MAP;

    constructor(private api: ApiService) { }

    initializeMetricMap() {
        return this.api.get('questionnaire/language/en-au/metrics').pipe(map(response => {
            this.data = response;
            this.metrics = this.data;
            this.metrics.forEach(metric => {
                this.metrics_parent_map.set(metric.id, metric.name);
            });
          }),
          catchError((error: HttpErrorResponse) => {
            console.log(error)
            throw error;
          }))
    }

    getMetricIcon(metric, type='exit') {
        if (metric) {
            if( metric.name && this.METRICS_ICON_MAP[metric.name] ) {
                return this.METRICS_ICON_MAP[metric.name];
            }
            if( metric.parent && this.metrics_parent_map && this.metrics_parent_map.get(metric.parent) ) {
                return this.METRICS_ICON_MAP[this.metrics_parent_map.get(metric.parent)];
            }
            // Just for report page, won't be needed when the employee feedback has the full metric object
            if( this.METRICS_ICON_MAP[metric] ) {
                return this.METRICS_ICON_MAP[metric];
            }
        }
        return this.METRICS_ICON_MAP['Organisational strategy'];
    }
}
